Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "FirstPost616981096",
  {"root":"FirstPost616981096--root","description":"FirstPost616981096--description"},
  "",
  1,
  "FirstPost616981096"
);

